export const CodeSpecNum = {
    AssetGroupCode: 1,
    TaskGroupCode: 2,
    AssetLocation: 3,
    DiligenceCode: 4,
    AssetMemo:5,
    PurchaseGroupCode: 6,
    PurchaseSupplyMethodCode: 7,
    PurchaseSupplyCategoryCode: 8,
    RentalAssetCode: 9,
    InspectionRequestCode: 10,
    IncidentRequestCode: 11,
    WorkRequestCode: 12,
    IntroductionRequestCode : 13,
    DisposeRequestCode : 14,

    ClaimCode: 15,
    SlaGroupCode: 16,
    ServiceRequestGroupCode: 1,
    CompanyParentKey : 1
}

export const urlBinder = {
    Asset: '/asset',
    Purchase: '/asset/purchase',
    Diligence: '/diligence',
    License: '/license',
    AssetContract : "/asset/contract",
    AssetDepreciation : "/asset/depreciation",
    AssetLease : "/asset/lease",
    Inspection : "/maintenance/inspection",
    Incident : "/maintenance/incident",
    InspectionHeader : "/maintenance/inspection_header",
    Work : "/maintenance/work",
    Company : "/settings/company",
    ServiceApply : "/serviceRequest/serviceApply",
    InspectionReportCode : "/settings/report"
}

export const ContentCategory = {
    SERVICE_APPLY: "SERVICE_APPLY",
    SERVICE_REQUEST: "SERVICE_REQUEST",
    SERVICE_REQUEST_IN_PROGRESS: "SERVICE_REQUEST_IN_PROGRESS",
    SERVICE_CODE: "SERVICE_CODE",
    SERVICE: "SERVICE",
    DILIGENCE: "DILIGENCE",
    INSPECTION : "INSPECTION",
    INSPECTION_HEADER : "INSPECTION_HEADER",
    INSPECTION_PRE_APPROVE : "INSPECTION_PRE_APPROVE",
    INSPECTION_POST_APPROVE : "INSPECTION_POST_APPROVE",
    INSPECTION_IN_PROGRESS: "INSPECTION_IN_PROGRESS",
    INSPECTION_CODE: "INSPECTION_CODE",
    INCIDENT : "INCIDENT",
    INCIDENT_PRE_APPROVE : "INCIDENT_PRE_APPROVE",
    INCIDENT_POST_APPROVE : "INCIDENT_POST_APPROVE",
    INCIDENT_IN_PROGRESS: "INCIDENT_IN_PROGRESS",
    INCIDENT_CODE: "INCIDENT_CODE",
    WORK : "WORK",
    WORK_CODE: "WORK_CODE",
    WORK_PRE_APPROVE : "WORK_PRE_APPROVE",
    WORK_POST_APPROVE : "WORK_POST_APPROVE",
    WORK_IN_PROGRESS: "WORK_IN_PROGRESS",
    NONE : "NONE",
    COMPANY : "COMPANY",
    CODE : "CODE",
    EVALUATION_REPORT : "EVALUATION_REPORT",
    DAILY_CHECK_REPORT : "DAILY_CHECK_REPORT",
    INTRODUCTION : "INTRODUCTION",
    DISPOSE : "DISPOSE",
    RENTAL_ASSET: "RENTAL_ASSET",
    COMPUTER_ROOM: "COMPUTER_ROOM",
}

export const ApprovalType = {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    APPROVAL_PASSED: "APPROVAL_PASSED",
    DONE: "DONE",
    HAS_NO_APPROVERS : "HAS_NO_APPROVERS"
}

export const ContentStatus = {
    PRE_INSERT: {statusNumericValue: 5, statusKorValue:"등록전", statusValue:"PRE_INSERT"},
    APPLY_APPROVE: {statusNumericValue: 10, statusKorValue:"신청결재", statusValue:"APPLY_APPROVE"},
    PRE_REGISTER: {statusNumericValue: 20, statusKorValue: "등록전", statusValue: "PRE_REGISTER"},
    APPROVE: {statusNumericValue: 30, statusKorValue: "결재", statusValue: "APPROVE"},
    EXAMINE: {statusNumericValue: 40, statusKorValue: "검토", statusValue: "EXAMINE"},
    IN_PROGRESS: {statusNumericValue: 50, statusKorValue: "진행", statusValue: "IN_PROGRESS"},
    VERIFICATION: {statusNumericValue: 60, statusKorValue: "검수", statusValue: "VERIFICATION"},
    POST_APPROVE: {statusNumericValue: 70, statusKorValue: "사후결재", statusValue: "POST_APPROVE"},
    FEEDBACK: {statusNumericValue: 80, statusKorValue: "만족도조사", statusValue: "FEEDBACK"},
    COMPLETE: {statusNumericValue: 90, statusKorValue: "완료", statusValue: "COMPLETE"},
    REJECT: {statusNumericValue: 1000, statusKorValue: "반려", statusValue: "REJECT"},
    NONE: {statusNumericValue: 2000, statusKorValue: "반려아님", statusValue: "NONE"}
}

export const DrawerType = {
    APPROVAL_PROCESS: "APPROVAL_PROCESS",
    APPROVAL_PROCESS_AFTER: "APPROVAL_PROCESS_AFTER",
    APPROVAL_GROUP: "APPROVAL_GROUP",
    APPROVAL_GROUP_LIST:"APPROVAL_GROUP_LIST",
    USER: "USER",
    USER_LIST: "USER_LIST",
    REQUESTER: "REQUESTER",
    APPLIER: "APPLIER",
    HANDLER: "HANDLER",
}

// contentSlice 에 들어갈 필드를 명시함
export const UserType = {
    requesters : "requesters", appliers: "appliers", handlers: "handlers", users: "users", userGroup:"userGroup",
    requester : "requester", applier: "applier", handler: "handler", user: "user", transferer: "transferer",
    serviceCode: "serviceCode",operator:"operator",
    approvers: "approvers",
    rentUser: "rentUser"
}

export const UserIdType = {
    requesterId : "requesterId", applierId : "applierId",
    handlerIds : "handlerIds", handlerId: "handlerId",
    transfererId: "transfererId", userId: "userId",
    rentUserId: "rentUserId"
}

export const CodeType = {
    serviceCode: "serviceCode", approvalProcess: "approvalProcess", approvalProcessAfter: "approvalProcessAfter", approvalGroup: "approvalGroup",
    rentalAssetCode: "rentalAssetCode"
}

// 배열을 돌며 해당 값이 있으면 캐시를 지움
export const CacheType = {
    code : ["code", "group", "task", "location", "workCode", "inspectionCode", "incidentCode", "workCode", "introductionCode", "disposeCode"],
    project : ["project"],
    serviceCode: ["serviceCode"],
    userAccount : ["userAccount"],
    department : ["department"],
    company : ["company"],
    asset : ["asset", "depreciationAsset", "asset-diligence", "dispose", "rental", "maintenance-assets"],
    customCode : ["customCode"],
    userGroup : ["userGroup"],
    approvalProcess: ["approvalProcess", "approvalProcessAfter"],
    approvalGroup: ["approvalGroup"],
    contract : ["contract", "contracts"],
    SERVICE_REQUEST : ["SERVICE_REQUEST"],
    INCIDENT : ["INCIDENT"],
    INSPECTION : ["INSPECTION"],
    rentalAssetCode: ["rentalAssetCode"],
    RENTAL_ASSET : ["RENTAL_ASSET"],
    dailyCheck : ["dailyCheck"],
    inspectionReportAsset : ["inspectionReportAsset"],
    inspectionReportCompany : ["inspectionReportCompany"]

}

export const CodeIdType = {
    serviceCodeId: "serviceCodeId", rentalAssetCodeId: "rentalAssetCodeId", approvalProcessId: "approvalProcessId",
}

export const ExamineType = {
    ADJUST: "ADJUST", TRANSFER: "TRANSFER", REJECT: "REJECT",
    NEXT_STATUS: "NEXT_STATUS",
}

export const RentalType =  Object.freeze({
    AVAILABLE: {value: "AVAILABLE", kor: "대여가능"},
    UN_AVAILABLE: {value: "UN_AVAILABLE", kor: "대여불가능"},
    RENT: {value: "RENT", kor: "대여중"},
    REQUEST: {value: "REQUEST", kor: "대여신청"},
    CANCEL: {value: "CANCEL", kor: "대여취소"},
    REJECT: {value: "REJECT", kor: "대여거절"},
    RETURN: {value: "RETURN", kor: "반납완료"},
    OCCUPIED: {value: "OCCUPIED", kor: "대여예약"}
});

export const RentalActiveType = {
    ACTIVE: {value: "ACTIVE", kor: "대여가능", getActive: true},
    INACTIVE: {value: "INACTIVE", kor: "대여불가", getActive: false},
}

export const OverviewType = {
    EXCELLENT: {value: 'EXCELLENT', kor: 'A(탁월)', scale: "95이상"},
    OUTSTANDING: {value: 'OUTSTANDING', kor: 'B(우수)', scale: "85이상 95미만"},
    AVERAGE: {value: 'AVERAGE', kor: 'C(보통)', scale: "75이상 85미만"},
    INSUFFICIENT: {value: 'INSUFFICIENT', kor: 'D(미흡)', scale: "65이상 75미만"},
    POOR: {value: 'POOR', kor: 'E(불량)', scale: "65미만"},
}

// userRole과 일치해야함
export const userAuth = {
    USER : {numericValue : 5, value : 'USER', kor : '사용자', auth: 'ROLE_USER'},
    VIEW : {numericValue : 10, value : 'VIEW', kor : '읽기권한', auth: 'ROLE_VIEW'},
    ADMIN : {numericValue : 15, value : 'ADMIN', kor : '관리자', auth: 'ROLE_ADMIN'},
    SYSTEM : {numericValue : 20, value : 'SYSTEM', kor : '시스템 관리자', auth: 'ROLE_SYSTEM'},
}

export const childrenKeys = {
    group : "groupList",
    task : "taskList",
    location : "locationList",
    category : "categoryList",
    inspect : "inspectList",
    incident : "incidentList",
    work : "workList",
    dailyCheck : "dailyCheckCodeList",
    introductionCode : "introductionCodeList",
    disposeCode : "disposeCodeList",
    department : "departmentList",
    serviceCode : "serviceCodeList",
    method : "methodList",
    rentalAssetCode : "rentalAssetCodeList",
    slaGroup : "slaGroupList"

}